import * as React from "react";
import { cn } from "@/utils/functions/tailwind";

interface DisplayFieldProps {
  label: React.ReactNode;
  value: React.ReactNode;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

export function DisplayField({
  label,
  value,
  className,
  labelClassName,
  valueClassName,
}: DisplayFieldProps) {
  // Notes: Pass in className="text-unset" to override text-muted-foreground. Useful for when the background is dark (e.g. Create Insight Audience Preview)
  return (
    <div
      className={cn(
        "flex flex-col items-start text-muted-foreground",
        className
      )}
    >
      <div
        className={cn(
          "h5 !text-left !mb-0 uppercase opacity-50",
          labelClassName
        )}
      >
        {label}
      </div>
      <div className={cn("p font-semibold", valueClassName)}>{value}</div>
    </div>
  );
}

export default DisplayField;
